import React, { useState } from 'react';
import { toast } from 'sonner';
import { LifeBuoy } from 'lucide-react';
import { Panel } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';

export default function Support() {
  const { data: faq } = useFetch('/faq');
  const [msg, setMsg] = useState('');
  return (
    <div className="space-y-6 max-w-3xl" data-testid="support-page">
      <Panel title="Contact Support">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-lg bg-vj-neon/10 grid place-items-center"><LifeBuoy size={18} className="text-vj-neon" /></div>
          <p className="text-sm text-vj-grey">Describe your issue and our team will respond. For deposit questions, include your transaction hash.</p>
        </div>
        <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={4} placeholder="How can we help?" className="w-full p-3 rounded-lg bg-vj-charcoal border border-border text-sm text-foreground focus:border-vj-neon/60 focus:outline-none" data-testid="support-message" />
        <button onClick={() => { if (msg.trim()) { toast.success('Support request submitted'); setMsg(''); } }} className="mt-3 h-11 px-6 rounded-lg bg-vj-neon text-vj-obsidian font-semibold text-sm vj-glow-green" data-testid="support-submit">Submit Request</button>
      </Panel>
      <Panel title="Frequently Asked Questions">
        <Accordion type="single" collapsible>
          {(faq || []).map((f) => (
            <AccordionItem key={f.id} value={f.id}>
              <AccordionTrigger className="text-sm text-left">{f.question}</AccordionTrigger>
              <AccordionContent className="text-sm text-vj-grey">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Panel>
    </div>
  );
}
